import React from 'react';

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
    error?: boolean;
    options?: Array<{ value: string; label: string }>;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(({
    className = "",
    error = false,
    children,
    options,
    ...props
}, ref) => {
    return (
        <select
            ref={ref}
            className={`
        w-full bg-[#faebd7] dark:bg-[#4e342e] 
        border-2 border-[#8b4513] dark:border-[#8d6e63]
        text-wood-darker dark:text-[#f3e5f5]
        px-3 py-2
        outline-none
        focus:border-[#ffcc80] dark:focus:border-[#ffd54f]
        focus:shadow-[0_0_0_2px_#8b4513] dark:focus:shadow-[0_0_0_2px_#8d6e63]
        disabled:opacity-50 disabled:cursor-not-allowed
        transition-all duration-150
        jagged-corners
        appearance-none
        bg-[url('data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%238b4513%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E')]
        bg-[length:0.7em] bg-[right_0.7rem_center] bg-no-repeat
        ${error ? 'border-red-500 focus:border-red-500' : ''}
        ${className}
      `}
            {...props}
        >
            {options?.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
            {children}
        </select>
    );
});

Select.displayName = "Select";
